/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* stats-service.ts  2026-08-26T09:15:21+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';


const _ = 'Stats/';

export class StatsService {

  constructor(readonly r: RpcService) {}
  // 增加评论浏览量，一批最多20个评论id
  incCmtView(d:Array<number>, m?: M): R<boolean>{
    return this.r.async(_ + 'incCmtView', d, m);
  }
}
